import { TDropItem } from 'src/types';

export const satAdminDateOptions: TDropItem[] = [
    { value: '11/02/2024', label: 'Nov 2, 2024' },
    { value: '12/07/2024', label: 'Dec 7, 2024' },
    { value: '03/08/2025', label: 'Mar 8, 2025' },
    { value: '05/03/2025', label: 'May 3, 2025' },
    { value: '06/07/2025', label: 'June 7, 2025' },
];
